export enum WholesaleApiQueryKey {
  GetProductNotificationSubscription = 'getProductNotificationSubscription',
  GetTopOrderedProducts = 'getTopOrderedProducts',
  CalculateLoyaltyForecastTier = 'calculateLoyaltyForecastTier',
}
